// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type OptionsTabQueryVariables = Types.Exact<{
  filter: Types.CostOptionGroupSummariesFilter;
}>;


export type OptionsTabQuery = { __typename?: 'Query', costOptionGroupSummaries: Array<{ __typename?: 'CostOptionGroupRollup', locationName?: string | null | undefined, optionCode?: string | null | undefined, globalOptionGroup: { __typename?: 'GlobalOptionGroup', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } }, costs: { __typename?: 'RollupStats', minInCents: number, maxInCents: number, averageInCents: number, deltaInCents: number, deltaPercentage?: number | null | undefined }, prices: { __typename?: 'RollupStats', minInCents: number, maxInCents: number, averageInCents: number, deltaInCents: number, deltaPercentage?: number | null | undefined }, offerings: Array<{ __typename?: 'CostOptionGroupOffering', status: Types.CostOptionGroupOfferingStatus, productOffering: { __typename?: 'ProductOffering', id: string, name: string }, summary?: { __typename?: 'CostOptionGroupSummary', id: string, minCostInCents: number, maxCostInCents: number, deltaCostInCents: number, deltaCostPercentage?: number | null | undefined, minPriceInCents: number, maxPriceInCents: number, deltaPriceInCents: number, deltaPricePercentage?: number | null | undefined } | null | undefined }> }> };

export type OptionsTab_CostOptionGroupRollupFragment = { __typename?: 'CostOptionGroupRollup', locationName?: string | null | undefined, optionCode?: string | null | undefined, globalOptionGroup: { __typename?: 'GlobalOptionGroup', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } }, costs: { __typename?: 'RollupStats', minInCents: number, maxInCents: number, averageInCents: number, deltaInCents: number, deltaPercentage?: number | null | undefined }, prices: { __typename?: 'RollupStats', minInCents: number, maxInCents: number, averageInCents: number, deltaInCents: number, deltaPercentage?: number | null | undefined }, offerings: Array<{ __typename?: 'CostOptionGroupOffering', status: Types.CostOptionGroupOfferingStatus, productOffering: { __typename?: 'ProductOffering', id: string, name: string }, summary?: { __typename?: 'CostOptionGroupSummary', id: string, minCostInCents: number, maxCostInCents: number, deltaCostInCents: number, deltaCostPercentage?: number | null | undefined, minPriceInCents: number, maxPriceInCents: number, deltaPriceInCents: number, deltaPricePercentage?: number | null | undefined } | null | undefined }> };

export type OptionsTab_RollupStatsFragment = { __typename?: 'RollupStats', minInCents: number, maxInCents: number, averageInCents: number, deltaInCents: number, deltaPercentage?: number | null | undefined };

export const OptionsTab_RollupStatsFragmentDoc = gql`
    fragment OptionsTab_RollupStats on RollupStats {
  minInCents
  maxInCents
  averageInCents
  deltaInCents
  deltaPercentage
}
    `;
export const OptionsTab_CostOptionGroupRollupFragmentDoc = gql`
    fragment OptionsTab_CostOptionGroupRollup on CostOptionGroupRollup {
  globalOptionGroup {
    id
    name
    type {
      ...Named
    }
  }
  locationName
  optionCode
  costs {
    ...OptionsTab_RollupStats
  }
  prices {
    ...OptionsTab_RollupStats
  }
  offerings {
    productOffering {
      ...Named
    }
    status
    summary {
      id
      minCostInCents
      maxCostInCents
      deltaCostInCents
      deltaCostPercentage
      minPriceInCents
      maxPriceInCents
      deltaPriceInCents
      deltaPricePercentage
    }
  }
}
    ${NamedFragmentDoc}
${OptionsTab_RollupStatsFragmentDoc}`;
export const OptionsTabDocument = gql`
    query OptionsTab($filter: CostOptionGroupSummariesFilter!) {
  costOptionGroupSummaries(filter: $filter) {
    ...OptionsTab_CostOptionGroupRollup
  }
}
    ${OptionsTab_CostOptionGroupRollupFragmentDoc}`;

/**
 * __useOptionsTabQuery__
 *
 * To run a query within a React component, call `useOptionsTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsTabQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useOptionsTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OptionsTabQuery, OptionsTabQueryVariables> & ({ variables: OptionsTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OptionsTabQuery, OptionsTabQueryVariables>(OptionsTabDocument, options);
      }
export function useOptionsTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OptionsTabQuery, OptionsTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OptionsTabQuery, OptionsTabQueryVariables>(OptionsTabDocument, options);
        }
// @ts-ignore
export function useOptionsTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OptionsTabQuery, OptionsTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionsTabQuery, OptionsTabQueryVariables>;
export function useOptionsTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionsTabQuery, OptionsTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OptionsTabQuery | undefined, OptionsTabQueryVariables>;
export function useOptionsTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OptionsTabQuery, OptionsTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OptionsTabQuery, OptionsTabQueryVariables>(OptionsTabDocument, options);
        }
export type OptionsTabQueryHookResult = ReturnType<typeof useOptionsTabQuery>;
export type OptionsTabLazyQueryHookResult = ReturnType<typeof useOptionsTabLazyQuery>;
export type OptionsTabSuspenseQueryHookResult = ReturnType<typeof useOptionsTabSuspenseQuery>;
export type OptionsTabQueryResult = ApolloReactCommon.QueryResult<OptionsTabQuery, OptionsTabQueryVariables>;